import { IntegrationAction } from '../../reducers/airbnb/actionNames'

export const getAirbnbIntegration = () => ({
  type: IntegrationAction.GET_STATUS,
})

export const integrateAirbnbAccount = (payload) => ({
  type: IntegrationAction.CreateIntegration,
  code: payload.code,
})

export const setAirbnbTab = (payload) => ({
  type: IntegrationAction.SetTab,
  payload,
})

export const toggleAirbnbNotAllModal = (payload) => ({
  type: IntegrationAction.ToggleNotAllModal,
  payload,
})

export const deleteListing = (payload) => ({
  type: IntegrationAction.DeleteListing,
  payload: payload,
})

export const createListing = (payload) => ({
  type: IntegrationAction.CreateListing,
  payload,
})

export const setAirbnbPriceTab = (payload) => ({
  type: IntegrationAction.SetPriceTab,
  payload,
})

export const getAirbnbRoomConfiguration = (payload) => ({
  type: IntegrationAction.FetchRoomConfiguration,
  payload,
})

export const toggleAirbnbSync = (payload) => ({
  type: IntegrationAction.ToggleSync,
  payload,
})
